export default __webpack_public_path__ + "static/media/DelinquencyPolicy.fbd175be.pdf";